import React, { useRef } from "react";
import MailUs from "../MailUs/MailUs";
import "./service.css";
import { useNavigate } from "react-router-dom";

const IndServBody = ({ individual }) => {
  const navigate = useNavigate();

  // Create a ref for the features section
  const featuresRef = useRef(null);

  // Scroll to the features section
  const scrollToFeatures = () => {
    featuresRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <>
      <div className="container-fluid mt-4 mb-4">
        <div className="row">
          {/* Service Information */}
          <div className="col-md-6 ind-serv-details">
            <p className="ind-serv-name">
              {individual?.service || "Service Name"}
            </p>
            <p className="ind-serv-slogan">
              {individual?.slogan || "Service Slogan"}
            </p>
            <p className="ind-serv-desc">
              {individual?.description || "Description not available."}
            </p>
            <div className="ind-serv-btn-wrapper">
              <button onClick={scrollToFeatures}>{`${individual?.service || "Service"} Benefits`}</button>
              &nbsp;&nbsp;&nbsp;
              <button onClick={() => navigate("/contact")}>Reach Us</button>
            </div>
          </div>

          {/* Benefits Section */}
          <div className="col-md-6 d-flex justify-content-center align-items-center">
            <div>
              <h3 className="ind-serv-benefit-head">
                Benefits of {individual?.service}
              </h3>
              <ul>
                {individual?.benefit.map((eachbenefit) => {
                  return (
                    <li className="ind-serv-benefit-list" key={eachbenefit.percentage}>
                      <span className="ind-serv-benefit-percent">
                        {eachbenefit.percentage}%
                      </span>{" "}
                      <span className="ind-serv-benefit-point">
                        {eachbenefit.points}
                      </span>
                    </li>
                  );
                })}
              </ul>
            </div>
          </div>

          {/* Service Video */}
          <div className="col-md-12 mt-5 ind-serv-youtube">
            {individual?.link ? (
              <iframe
                width="100%"
                height="100%"
                src={individual.link}
                title="YouTube video player"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              ></iframe>
            ) : (
              <p>No video available.</p>
            )}
          </div>
        </div>
      </div>

      {/* Features Section */}
      <div ref={featuresRef} className="row ind-serv-feat-wrapper">
        {individual?.features.map((eachfeature, index) => {
          return (
            <div
              className="col-md-6 mt-5"
              style={{ display: "flex", justifyContent: "center" }}
              key={index}
            >
              <div className="ind-serv-feat-card">
                <h4>{eachfeature.feathead}</h4>
                <p className="mt-4">{eachfeature.featdesc}</p>
              </div>
            </div>
          );
        })}
      </div>

      <MailUs />
    </>
  );
};

export default IndServBody;
